import { UISelectorType } from "../../../utilities/types";
import { GeneralCategory, GeneralCustomizationEntry, GeneralSubCategory } from "./types";

export const generalCustomizeEntries: GeneralCustomizationEntry[] = [
    // Activation and Experience
    {
        id: 'showVoiceChatSwitch',
        displayName: 'Activate Voice snippet in chat',
        category: GeneralCategory.ActivationAndModes,
        subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'showAvatarChatSwitch',
        displayName: 'Activate Avatar snippet in chat',
        category: GeneralCategory.ActivationAndModes,
        subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    // {
    //     id: 'startDirectlyOnVoice',
    //     displayName: 'Start in voice mode',
    //     category: GeneralCategory.ActivationAndModes,
    //     subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
    //     uiSelectorType: UISelectorType.switchSelector,
    //     containerName: "root",
    // },
    // {
    //     id: 'startDirectlyOnAvatar',
    //     displayName: 'Start in avatar mode',
    //     category: GeneralCategory.ActivationAndModes,
    //     subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
    //     uiSelectorType: UISelectorType.switchSelector,
    //     containerName: "root",
    // },
    {
        id: 'activateDictationInChatSnippet',
        displayName: 'Activate dictation in chat snippet',
        category: GeneralCategory.ActivationAndModes,
        subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'snippetExperience',
        displayName: 'Experience',
        category: GeneralCategory.ActivationAndModes,
        subCategory: GeneralSubCategory.ChatAndVoiceSwitching,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "root",
    },
    {
        id: 'isDisabled',
        displayName: 'Disable widget',
        category: GeneralCategory.ActivationAndModes,
        subCategory: GeneralSubCategory.WidgetAvailability,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },

    // Launcher
    {
        id: 'closeButtonEnabled',
        displayName: 'Show collapse control',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Behavior,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'v2_containerElement_expand_icon',
        displayName: 'Expand icon',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_containerElement_collapse_icon',
        displayName: 'Collapse icon',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'launcherBackgroundColor',
        displayName: 'Background color',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Colors,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'launcherBackgroundColorHover',
        displayName: 'Background color (hover)',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Colors,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'launcherIconColor',
        displayName: 'Icon color',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Colors,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'launcherIconColorOnHover',
        displayName: 'Icon color (hover)',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.Colors,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'containerElementBannerEnabled',
        displayName: 'Show launcher welcome banner',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'containerElementBannerDelayInSeconds',
        displayName: 'Welcome banner delay (seconds)',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'containerElementFirstBannerRowHtml',
        displayName: 'Welcome banner first row (HTML)',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'containerElementSecondBannerRowHtml',
        displayName: 'Welcome banner second row (HTML)',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'containerElementBannerDismissButtonEnabled',
        displayName: 'Show banner dismiss button',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'containerElementBannerPersistDismiss',
        displayName: 'Remember banner dismissal',
        category: GeneralCategory.Launcher,
        subCategory: GeneralSubCategory.WelcomeBanner,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },

    // Placement & opening
    {
        id: 'position',
        displayName: 'Screen side',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.ScreenPlacement,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "UI",
    },
    {
        id: 'floatRight',
        displayName: 'Distance from right edge (%)',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.ScreenPlacement,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'bottom',
        displayName: 'Distance from bottom',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.ScreenPlacement,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'top',
        displayName: 'Distance from top',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.ScreenPlacement,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'autoExpandEnabled',
        displayName: 'Open expanded',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.OpeningBehavior,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'autoExpandEnabledOnlyOnDesktop',
        displayName: 'Open expanded on desktop only',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.OpeningBehavior,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'fullScreenMode',
        displayName: 'Full-screen mode',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.OpeningBehavior,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },
    {
        id: 'showPoweredBy',
        displayName: 'Show "Powered by Druid"',
        category: GeneralCategory.PlacementAndOpening,
        subCategory: GeneralSubCategory.OpeningBehavior,
        uiSelectorType: UISelectorType.switchSelector,
        containerName: "UI",
    },

    // Connection & session
    {
        id: 'queryParams',
        displayName: 'URL query parameters',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Integration,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'otherServicesEndpointIndex',
        displayName: 'Service endpoint index (on-premise)',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Integration,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "root",
    },
    {
        id: 'heartBeatUrl',
        displayName: 'Keep-alive endpoint URL',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Integration,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'backgroundTrafficEnabled',
        displayName: 'Send telemetry',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Integration,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'authorizationUrl',
        displayName: 'Authorization path',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Authentication,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'authorizationBaseUrl',
        displayName: 'Authorization base URL',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Authentication,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'withCredentials',
        displayName: 'Send credentials on API calls',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Authentication,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'withCredentials_authorization',
        displayName: 'Send credentials on auth calls',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.Authentication,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'conversationTokenEnabled',
        displayName: 'Remember returning users',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'druidCookiesExpirationInDays',
        displayName: 'Cookie lifetime (days)',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'conversationToken_namePrefix',
        displayName: 'Conversation cookie prefix',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'druidWebChatIsOpenedEnabled',
        displayName: 'Remember open/closed state',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'druidWebChatIsOpened_namePrefix',
        displayName: 'Open-state cookie prefix',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
    {
        id: 'druidCookieConsentEnabled',
        displayName: 'Require cookie consent',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'cookieDomain',
        displayName: 'Cookie domain',
        category: GeneralCategory.ConnectionAndSession,
        subCategory: GeneralSubCategory.SessionAndCookies,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
    },
];
